import { createSelector } from "reselect";

import { getSearchedLegSegments } from "./get-segments";

export const areTripStopsLoaded = createSelector(
  [getSearchedLegSegments],
  (trip_segments): boolean => {
    return trip_segments.every(segment => segment.hasOwnProperty("stops"));
  }
);
